import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Bot, Sparkles } from 'lucide-react';

import CoachChatWindow from './CoachChatWindow';

const AICoachWidget = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <AnimatePresence>{isOpen && <CoachChatWindow onClose={() => setIsOpen(false)} />}</AnimatePresence>
      <motion.button
        type="button"
        whileHover={{ y: -2, scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        onClick={() => setIsOpen((value) => !value)}
        className="fixed bottom-5 right-5 z-50 inline-flex h-14 w-14 items-center justify-center rounded-full border border-white/15 bg-gradient-to-r from-purple-500 to-pink-500 text-white shadow-[0_0_32px_rgba(236,72,153,0.55)]"
        aria-label="Open AI Career Coach"
      >
        <Bot size={24} aria-hidden="true" />
        <Sparkles className="absolute -right-1 -top-1 text-fuchsia-100" size={16} aria-hidden="true" />
      </motion.button>
    </>
  );
};

export default AICoachWidget;
